import store from "@/state/store";
import mqttService from "@/services/mqtt.service";

export default [
  // --- KİMLİK DOĞRULAMA (AUTH) ---
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // Kullanıcı zaten giriş yapmışsa ana sayfaya at
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  // Eski tema linkleri: /auth/signin-basic -> /login (No match hatasını önler)
  { path: "/auth/signin-basic", redirect: "/login" },
  { path: "/auth/signin-cover", redirect: "/login" },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout",
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        // MQTT bağlantısını kapat; yeniden deneme dursun.
        mqttService.stop();

        // DeviceUniqueId cihaz bazlı olmalı; logout'ta silmeyelim.
        // User.API cihaz kuralları: aynı cihazdan farklı kullanıcılar giriş yapabilir,
        // aynı kullanıcı birden fazla cihaz kaydı tutabilir. DeviceUniqueId sabit kalmalı.
        const deviceUniqueId = localStorage.getItem("deviceUniqueId");

        localStorage.clear();
        sessionStorage.clear();

        if (deviceUniqueId) {
          try {
            localStorage.setItem("deviceUniqueId", deviceUniqueId);
          } catch {
            // ignore
          }
        }
        next();
      },
    },
    component: () => import("../views/auth/logout/basic"),
  },

  // --- ANA DASHBOARD ---
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    // Ana sayfa  
    component: () => import("../views/dashboard/dashboard.vue"),//dashboard.vue
  },



  // --- KULLANICI LİSTESİ ---
  {
    path: "/dashboard/userlist",
    name: "dashboard-userlist",
    meta: {
      title: "Userlist",
      authRequired: true,
    },
    component: () => import("../views/dashboard/users/userlist"),
  },

  // --- YARDIMCI SAYFALAR (HATA & BAKIM) ---
  // 404 Sayfası (Kullanıcı yanlış linke girerse lazım olur)
  {
    path: "/auth/404",
    name: "404",
    meta: {
      title: "Error 404",
      authRequired: true,
    },
    component: () => import("../views/auth/errors/404"),
  },
  // Bakım Modu Sayfası (İleride lazım olabilir, saklamakta fayda var)
  {
    path: "/pages/maintenance",
    name: "maintenance",
    meta: {
      title: "Maintanance",
      authRequired: true,
    },
    component: () => import("../views/pages/maintenance"),
  },
  //payment 
  {
    path: "/studio/payment",
    name: "payment",
    meta: { title: "Payment", authRequired: true },
    component: () => import("../views/payment/index.vue"),
  },
  // Profil Sayfası  
  {
    path: "/profile",
    name: "profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("../views/pages/profile/simple"),
  },
  {
    path: "/notifications",
    name: "notifications",
    meta: { title: "Notifications", authRequired: true },
    component: () => import("../views/notifications.vue"),
  },
  {
    path: "/pages/search-results",
    name: "search-results",
    meta: { title: "Search Results", authRequired: true },
    component: () => import("../views/pages/search-results"),
  },
  {
    path: '/auth/lockscreen-basic',
    name: 'lock-screen-basic',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/basic')
  },
  //welcome
   {
    path: '/welcome',
    name: 'welcome',
    meta: {
      title: "Welcome", authRequired: true,
    },
    component: () => import('../views/welcome.vue')
  },
  //STUDIO
  {
    path: '/studio/contracts',
    name: 'contracts',
    meta: {
      title: "Contracts", authRequired: true,
    },
    component: () => import('../views/studio/contracts.vue')
  },
  {
    path: '/create-studio',
    name: 'create-studio',
    meta: {
      title: "Create Studio", authRequired: true,
    },
    component: () => import('../views/studio/create-studio.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: "Contact", authRequired: true,
    },
    component: () => import('../views/studio/contact.vue')
  },
  {
    path: '/contact/category/:categoryId',
    name: 'contact-sessions',
    meta: {
      title: "Contact Sessions", authRequired: true,
    },
    component: () => import('../views/studio/contact-sessions.vue')
  },
  {
    path: '/contact/session/:sessionId',
    name: 'contact-session',
    meta: {
      title: "Contact Session", authRequired: true,
    },
    component: () => import('../views/studio/contact-chat.vue')
  },
  {
    path: '/studio/ask-us-groups',
    name: 'ask-us-groups',
    meta: {
      title: "Ask Us Groups", authRequired: true,
    },
    component: () => import('../views/studio/ask-us-groups.vue')
  },
  {
    path: '/studio/pre-program-questions',
    name: 'pre-program-questions',
    meta: {
      title: "Pre Program Questions", authRequired: true,
    },
    component: () => import('../views/studio/pre-program-questions.vue')
  },
  {
    path: '/studio/study/parq-questions',
    name: 'studio-parq-questions',
    meta: {
      title: "PARQ Questions",
      authRequired: true,
    },
    component: () => import('../views/studio/parq-questions.vue')
  },
  {
    path: '/join-studio',
    name: 'join-studio',
    meta: {
      title: "Join Studio", authRequired: true,
    },
    component: () => import('../views/studio/join-studio.vue')
  },
  {
    path: '/studio/employees',
    name: 'employees',
    meta: {
      title: "Employees", authRequired: true,
    },
    component: () => import('../views/studio/employees.vue')
  },
  {
    path: '/studio/employees-invitation-code',
    name: 'employees-invitation-code',
    meta: {
      title: "Employees invitation code", authRequired: true,
    },
    component: () => import('../views/studio/employees-code.vue')
  },
  {
    path: '/studio/member-invitation-code',
    name: 'member-invitation-code',
    meta: {
      title: "Member invitation code",
      authRequired: true,
    },
    component: () => import('../views/studio/member-invitation-code.vue')
  },
  {
    path: '/studio/member',
    name: 'member',
    meta: {
      title: "Member", authRequired: true,
    },
    component: () => import('../views/studio/member.vue')
  },
  {
    path: '/studio/member-packages',
    name: 'member-packages',
    meta: {
      title: "Member Packages", authRequired: true,
    },
    component: () => import('../views/studio/member-packages.vue')
  },
  {
    path: '/studio/member-package-cards',
    name: 'member-package-cards',
    meta: {
      title: "Antrenman Kartları", authRequired: true,
    },
    component: () => import('../views/studio/member-package-cards.vue')
  },
  {
    path: '/studio/member-package-diets',
    name: 'member-package-diets',
    meta: {
      title: "Diyetisyen Programları", authRequired: true,
    },
    component: () => import('../views/studio/member-package-diets.vue')
  },
  {
    path: '/studio/packages',
    name: 'packages',
    meta: {
      title: "Packages", authRequired: true,
    },
    component: () => import('../views/studio/packages.vue')
  },
  {
    path: '/studio/package-details',
    name: 'package-details',
    meta: {
      title: "Package Details",
      authRequired: true,
    },
    component: () => import('../views/studio/package-details.vue')
  },
  {
    path: '/studio/package-ref-codes',
    name: 'package-ref-codes',
    meta: {
      title: "Package Ref Codes",
      authRequired: true,
    },
    component: () => import('../views/studio/package-ref-codes.vue')
  },
  {
    path: '/studio/studio-info',
    name: 'studio-info',
    meta: {
      title: "Studio info", authRequired: true,
    },
    component: () => import('../views/studio/studio-info.vue')
  },
  {
    path: '/studio/studio-sessions',
    name: 'studio-sessions',
    meta: {
      title: "Studio Sessions", authRequired: true,
    },
    component: () => import('../views/calendar/calendar-package.vue')
  },
  //CALENDAR
   {
    path: '/studio/calendar-package',
    name: 'calendar-package',
    meta: {
      title: "Calendar", authRequired: true,
    },
    component: () => import('../views/calendar/calendar-package.vue')
  },
  //EXPIRED CARDS  
  {
    path: '/studio/expired-cards',
    name: 'expired-cards',
    meta: {
      title: "Expired Cards", authRequired: true,
    },
    component: () => import('../views/program-cards-activities/expired-cards.vue')
  },
  //EXPIRED DIETS
  {
    path: '/studio/expired-diets',
    name: 'expired-diets',
    meta: {
      title: "Expired Diets", authRequired: true,
    },
    component: () => import('../views/program-cards-activities/expired-diets.vue')
  },
  //PROGRAM CARDS
  {
    path: '/studio/program-cards',
    name: 'program-cards',
    meta: {
      title: "Program Cards", authRequired: true,
    },
    component: () => import('../views/program-cards-activities/program-cards.vue')
  },
  //DIET TEMPLATES
  {
    path: '/studio/diet-templates',
    name: 'diet-templates',
    meta: {
      title: "Diet Templates", authRequired: true,
    },
    component: () => import('../views/studio/diet-templates.vue')
  },
  //User Idle Actions
  {
    path: '/studio/user-idle-actions',
    name: 'user-idle-actions',
    meta: {
      title: "User Idle Actions", authRequired: true,
    },
    component: () => import('../views/program-cards-activities/user-idle-actions.vue')
  },
  //User Template Actions
  {
    path: '/studio/user-template-actions',
    name: 'user-template-actions',
    meta: {
      title: "User Template Actions", authRequired: true,
    },
    component: () => import('../views/program-cards-activities/user-template-actions.vue')
  },
];